<template>
  <admin-dashboard
    v-if="user.email && user.isAdmin"
    :user="user"
  />
  <user-dashboard
    v-else-if="user.subscription === 'extensive'"
    :user="user"
  />
  <simple-user-dashboard
    v-else
    :user="user"
  />
</template>

<script>
import { mapState } from 'vuex'
import AdminDashboard from '@/components/admin/AdminDashboard'
import UserDashboard from '@/components/user/UserDashboard'
import SimpleUserDashboard from './user/SimpleUserDashboard'
export default {
  name: 'Dashboard',
  components: { SimpleUserDashboard, AdminDashboard, UserDashboard },
  props: {
    msg: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapState(['user']),
  },
}
</script>

<style scoped></style>
